export const specialItems = [
  {
    id: 'special-01',
    title: '深空将至',
    subtitle: '科幻片单 · 当人类把目光投向更远的地方',
    accentLabel: '编辑精选',
    intro:
      '从空间站的失重走廊到极夜下的观测站，这一组作品把镜头对准了人类最古老的冲动——往更远处去。它们不急着展示奇观，而是先问一个更小的问题：当我们离开熟悉的地方，还剩下什么能证明自己是谁。',
    reason:
      '收录近三年口碑最高的硬核科幻与太空悬疑作品，兼顾宏大设定与个体情感，适合一次看完整季的深夜。',
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%2C%20a%20vast%20ringed%20planet%20rising%20over%20the%20curve%20of%20earth%2C%20a%20tiny%20spacecraft%20silhouette%2C%20deep%20indigo%20and%20amber%20tonal%20contrast%2C%20atmospheric%20nebula%20haze%2C%20no%20text&width=960&height=540&seq=special-01&orientation=landscape',
    movieIds: ['film-01', 'film-09', 'film-27', 'film-24', 'film-29', 'series-12', 'series-20', 'series-28'],
    relatedIds: ['special-05', 'special-02'],
  },
  {
    id: 'special-02',
    title: '迷雾剧场',
    subtitle: '悬疑犯罪 · 真相总在最后一集翻面',
    accentLabel: '高能推荐',
    intro:
      '一份被封存的旧档案、一列多出一个人的夜班车、一条永远走不到尽头的蓝色走廊。这里的每一个故事都从一个不起眼的细节开始，然后在最后二十分钟，把前面所有的判断全部推翻。',
    reason:
      '八部结构扎实的悬疑犯罪作品，全部采用多线叙事与反转收束，适合喜欢边看边推理的观众。',
    cover:
      'https://readdy.ai/api/search-image?query=Foggy%20nocturnal%20city%20alley%20with%20a%20single%20flickering%20street%20lamp%2C%20silhouetted%20detective%20figure%2C%20wet%20cobblestones%20and%20deep%20teal%20mist%20with%20faint%20amber%20light%2C%20cinematic%20mystery%20tone%2C%20no%20text&width=960&height=540&seq=special-02&orientation=landscape',
    movieIds: ['film-02', 'film-06', 'film-10', 'film-12', 'film-30', 'series-02', 'series-06', 'series-11'],
    relatedIds: ['special-01', 'special-04'],
  },
  {
    id: 'special-03',
    title: '人间烟火',
    subtitle: '治愈系 · 好好吃饭，好好告别',
    accentLabel: '口碑合集',
    intro:
      '没有拯救世界，也没有惊天反转。只有一间午夜面包店、一张只摆三桌的菜单、一个重新开始吃饭的人。生活很少给出答案，但它常常递来一碗热的东西。',
    reason:
      '为疲惫的夜晚准备的一组温柔片单，节奏舒缓、情绪克制，适合睡前或者周末的下午连着看。',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20warm%20evening%20street%20with%20a%20small%20glowing%20food%20stall%2C%20steam%20rising%20from%20a%20pot%2C%20paper%20lanterns%2C%20amber%20light%20against%20deep%20blue%20dusk%2C%20gentle%20cinematic%20mood%2C%20no%20text&width=960&height=540&seq=special-03&orientation=landscape',
    movieIds: ['film-03', 'film-15', 'film-23', 'film-26', 'series-03', 'series-08', 'series-10', 'series-21'],
    relatedIds: ['special-04', 'special-05'],
  },
  {
    id: 'special-04',
    title: '华语新势力',
    subtitle: '2026 国产新作 · 值得提前记下的名字',
    accentLabel: '年度前瞻',
    intro:
      '这一批作品里，有第一次执导长片的摄影师，也有从舞台剧转来的编剧。它们不约而同地把镜头转向具体的城市、具体的行业和具体的人，构成了今年最值得期待的一组华语新作。',
    reason:
      '精选 2026 年待播与在播的华语电影、剧集，涵盖古装、都市、科幻与工业题材，跟进最新的创作动向。',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20Chinese%20cinematic%20cityscape%20at%20blue%20hour%2C%20layered%20glass%20towers%20and%20old%20low-rise%20rooftops%2C%20warm%20amber%20window%20lights%2C%20soft%20haze%2C%20no%20text&width=960&height=540&seq=special-04&orientation=landscape',
    movieIds: ['film-24', 'film-05', 'series-02', 'series-07', 'series-01', 'series-11'],
    relatedIds: ['special-02', 'special-03'],
  },
  {
    id: 'special-05',
    title: '极地之光',
    subtitle: '自然与冒险 · 在地球的边界线上',
    accentLabel: '视觉盛宴',
    intro:
      '极夜里唯一的光，往往来自人自己。这一组作品把拍摄地推到冰盖、潮间带与无路荒野，用极度克制的镜头语言，记录人类在自然尺度下的渺小与固执。',
    reason:
      '适合大屏观看的一组高画质作品，画面与音效均为同类型中的上乘水准，建议戴上耳机。',
    cover:
      'https://readdy.ai/api/search-image?query=Sweeping%20arctic%20landscape%20with%20green%20aurora%20over%20endless%20ice%2C%20tiny%20expedition%20headlamps%20in%20the%20distance%2C%20deep%20polar%20blue%20snow%20shadows%2C%20cinematic%20epic%20scale%2C%20no%20text&width=960&height=540&seq=special-05&orientation=landscape',
    movieIds: ['film-05', 'film-24', 'film-27', 'film-16', 'series-15', 'series-28', 'series-20'],
    relatedIds: ['special-01', 'special-03'],
  },
];